export default {
  'component.tagSelect.expand': 'Mở rộng',
  'component.tagSelect.collapse': 'Thu gọn',
  'component.tagSelect.all': 'Tất cả',
};


